import { dataLoading } from "@/shared/decorators/LoadingAction.decorator";
import apiClient from "./ApiClientService";
import { UserProfile } from "@/shared/models/UserProfile";

export class UserProfileApi {
    @dataLoading(false)
  static async addUserProfile(userProfile: UserProfile): Promise<boolean> {
    const result = await apiClient.post("userprofile", userProfile);
    return result.status === 200;
  }

  @dataLoading(false)
  static async saveUserProfile(userProfile: UserProfile): Promise<boolean> {
    const result = await apiClient.put("userprofile", userProfile);
    return result.status === 200;
  }

  @dataLoading(null)
  static async getUserProfile(apexId: string): Promise<UserProfile | null> {
    const result = await apiClient.get(`userprofile/getuserprofile/${apexId}`);
    return result.status === 200 ? (result.data as UserProfile) : null;
  }
}
